import * as s from 'superstruct';

// Define the schema for a tag
export const Tag = s.object({
  id: s.string(),
  displayName: s.string(),
  description: s.optional(s.string()),
  isProduct: s.optional(s.boolean()),
});

// Export TypeScript type inferred from the schema
export type TagType = s.Infer<typeof Tag>; 